module.exports = __webpack_public_path__ + "img/infoSupport.994a4b10.png";